/**
 * English Home Translations
 * 首页翻译模块 - 英语
 * 
 * SEO 关键词覆盖：
 * - infrared heater manufacturer / supplier China
 * - far infrared radiant heater
 * - energy efficient infrared heater
 * - outdoor patio heater / restaurant / workshop
 * - wholesale / OEM
 */

import type { HomeTranslations } from '../../types';

export const enHome: HomeTranslations = {
  hero: {
    future: 'The Future of Heating',
    title: 'Efficient & Green',
    subtitle: 'Infrared Heating',
    description: 'Bring sun-like warmth to outdoor spaces. Our advanced far infrared technology delivers instant, silent, energy-efficient radiant heat for restaurant patios, gardens, workshops, and poolside areas.',
    cta: 'Explore Products',
    watchVideo: 'Watch Video',
    trusted: 'Trusted by 5,000+ Clients',
    worldwide: 'Worldwide distribution',
    slides: {
      "slide5": {
        "title": "Canton Fair",
        "subtitle": "Meet Us in Guangzhou",
        "description": "Meet JH Heatsup at the Canton Fair. Discover our heating solutions and explore opportunities to work together.",
        "exhibition": {
          "eyebrow": "JH HEATSUP · CANTON FAIR PREVIEW",
          "date": "15–19 October 2026",
          "venue": "Canton Fair Complex, Guangzhou",
          "boothLabel": "VISIT OUR BOOTH",
          "booth": "Hall 3.2 · Booth L16"
        }
      },
      "slide4": {
        "title": "Global Sources",
        "subtitle": "Consumer Electronics",
        "description": "Meet JH Heatsup in Hong Kong. Explore our heating solutions and discuss your next partnership.",
        "exhibition": {
          "eyebrow": "JH HEATSUP · HONG KONG EXHIBITION",
          "date": "11–14 October 2026",
          "venue": "AsiaWorld-Expo, Hong Kong",
          "boothLabel": "VISIT OUR BOOTH"
        }
      },
      slide1: {
        title: 'Efficient & Green',
        subtitle: 'Infrared Heating',
        description: 'Bring sun-like warmth to outdoor spaces. Our advanced far infrared technology delivers instant, silent, energy-efficient radiant heat for restaurant patios, gardens, workshops, and poolside areas.',
      },
      slide2: {
        title: 'Safe & Reliable',
        subtitle: 'Built for Everyday Use',
        description: 'Designed with IPX4 waterproof rating, overheat protection, and durable materials. Our infrared heaters deliver stable, reliable warmth day after day — safe to run all night.',
      },
      slide3: {
        title: 'Ultra Quiet',
        subtitle: 'Peaceful Warmth',
        description: 'Enjoy silent, glare-free radiant warmth that feels natural, without drying the air or circulating dust. Healthy infrared heating for homes and offices.',
      },
    },
  },
  about: {
    title: 'About JH Heatsup',
    subtitle: 'Leading the Way in Infrared Technology Since 2006',
    intro1: 'Fujian Jinghui Environmental Technology Co., Ltd. (JH Heatsup) is a leading infrared heater manufacturer in China, specializing in energy-efficient far infrared radiant heaters for residential and commercial use.',
    intro2: 'We focus on R&D, OEM/ODM manufacturing, and global distribution to provide high-quality infrared heaters to wholesale buyers worldwide. Our products carry CE, CB, SAA, and RoHS certifications, exported to 80+ countries across Europe, Australia, the Middle East, and Southeast Asia.',
    stats: {
      yearsExperience: 'Years Experience',
      countriesExported: 'Countries Exported',
      patents: 'Patents',
      satisfaction: 'Satisfaction',
    },
    ceoQuote: '"We are committed to creating a greener, warmer world through technology."',
    ceoLabel: '- CEO Message',
    factoryAlt: 'JH Heatsup infrared heater factory production line',
  },
  features: {
    title: 'Why Choose JH Infrared Heaters',
    subtitle: 'Our far-infrared technology mimics the sun\'s natural heating principle, warming objects and people directly rather than just the air. This makes infrared heaters up to 80% more energy efficient than traditional convection heaters.',
    energy: {
      title: 'Energy Efficient',
      desc: 'Up to 99% heat conversion efficiency — infrared radiant heaters use up to 80% less electricity than convection heaters',
    },
    quiet: {
      title: 'Ultra Quiet',
      desc: 'Fanless infrared design with zero light, zero noise, and zero dust circulation',
    },
    safe: {
      title: 'Safe & Reliable',
      desc: 'IPX4 waterproof infrared heaters with built-in overheat protection, safe for outdoor and indoor use',
    },
    smart: {
      title: 'Smart Control',
      desc: 'WiFi Tuya app control for remote temperature scheduling — save energy from your phone',
    },
  },
  categoriesSection: {
    title: 'Shop by category',
    subtitle: "Explore our infrared, portable, and gas heaters to find the best fit for your space — from outdoor patios to indoor living rooms.",
    viewAll: 'View all products',
    cards: {
      infrared: {
        badge: 'Popular',
        tagline: 'Far infrared radiant heaters for efficient, targeted warmth',
        description: 'Ideal for outdoor patios, restaurant terraces, workshops, warehouses, and wall-mounted indoor heating.',
        cta: 'Shop now',
      },
      portable: {
        tagline: 'Portable carbon fiber and halogen heaters for flexible warmth',
        description: 'Great for homes, offices, under-desk heating, and outdoor entertaining areas.',
        cta: 'Shop now',
      },
      gas: {
        tagline: "Gas patio heaters and fire tables for open-air warmth",
        description: "Create a welcoming outdoor space for restaurant terraces, gardens, and patio gatherings.",
        cta: "Shop now",
      },
    },
  },
  ctaSection: {
    title: 'Ready to upgrade your heating?',
    subtitle: 'Contact JH Heatsup today for wholesale pricing, OEM/ODM services, and a free consultation.',
    cta: 'Get a Quote',
  },
};
